module.exports = {
  module: 'msi.modals.close.controller',
  name: 'CloseModalController'
};

const inject = ['$uibModalStack'];

function CloseModalControllerFactory($modalStack) {
  class CloseModalController {
    dismiss() {
      const modal = $modalStack.getTop();
      if (modal) {
        $modalStack.dismiss(modal.key, 'corner x clicked');
      }
    }
  }

  return new CloseModalController();
}

CloseModalControllerFactory.$inject = inject;

angular.module(module.exports.module, ['ui.bootstrap'])
  .controller(module.exports.name, CloseModalControllerFactory);
